// extracted by mini-css-extract-plugin
export default {"topDiv":"BalanceCard_topDiv__PUNkY"};